import { Component, OnDestroy, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  standalone: false,
  selector: 'app-access-denied',
  templateUrl: './access-denied.component.html',
  styleUrls: ['./access-denied.component.scss']
})
export class AccessDeniedComponent implements OnInit, OnDestroy {
  timeUntilRedirect = 8;

  private ivl: ReturnType<typeof setInterval> | null = null;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.ivl = setInterval(() => {
      --this.timeUntilRedirect;
      if (this.timeUntilRedirect === 0) {
        this.clearTimer();
        this.navigateToLanding();
      }
    }, 1000);
  }

  ngOnDestroy(): void {
    this.clearTimer();
  }

  navigate() {
    this.clearTimer();
    this.navigateToLanding();
  }

  private clearTimer(): void {
    if (this.ivl) {
      clearInterval(this.ivl);
      this.ivl = null;
    }
  }

  private navigateToLanding(): void {
    const isReferrerSession = localStorage.getItem('isReferrerRole') === 'true' || !!localStorage.getItem('storedReferrerUser');
    if (isReferrerSession) {
      this.router.navigate(['/referrerportal/home'], { replaceUrl: true });
      return;
    }

    const isPatientSession = localStorage.getItem('isPatientRole') === 'true' || !!localStorage.getItem('storedPatient');
    if (isPatientSession) {
      this.router.navigate(['/patientportal/home'], { replaceUrl: true });
      return;
    }

    // Use a query param so app-level '/landing' -> '/landing/case-view' redirect does not immediately
    // bounce users back through access-denied when they lack case-view role.
    this.router.navigate(['/landing'], {
      queryParams: { from: 'access-denied' },
      replaceUrl: true
    });
  }
}
